import styled, { css } from 'styled-components';

export const Container = styled.div`
  text-align: center;
`;

export const ContainerInner = styled.div`
  display: inline-block;
  max-width: 500px;
  width: 100%;
  background: #fff;
  ${props =>
    props.nobg &&
    css`
      background: transparent;
    `}
  box-sizing: border-box;
  opacity: ${props => props.alpha};
  transition: 0s all ease-in-out;
  padding: 20px 40px;
  text-align: left;
  ${props =>
    props.nopadding &&
    css`
      padding: 0;
    `}
  ${props =>
    props.flex &&
    css`
      display: flex;
      align-items: center;
    `}
  ${props =>
    props.centered &&
    css`
      justify-content: center;
      text-align: center;
    `}
`;
